import { GeofencesEditPage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeofencesEditRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      permission="journeys/geofences/edit"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geofences',
          params: { workspaceId: params.workspaceId },
        }).href
      }
    >
      <GeofencesEditPage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geofences/$geofenceId')({
  component: GeofencesEditRoute,
});
